import securityWorker from '@/auth/SecurityWorker';
import { setToken } from '@/http/token';
let $httpChangiRecommends;
let $httpPhoenix;
let $httpProductEditor;
function generateApis(apiFactory) {
    const { ChangiRecommendsApi, phoenixApi, productEditorApi } = apiFactory();
    $httpChangiRecommends = ChangiRecommendsApi;
    $httpPhoenix = phoenixApi;
    $httpProductEditor = productEditorApi;
}
function authorizeApis(userToken) {
    if (!securityWorker) {
        throw new Error('No valid security worker setted');
    }
    setToken(userToken);
    $httpChangiRecommends.setSecurityData({ userToken });
    $httpPhoenix.setSecurityData({ userToken });
    $httpProductEditor.setSecurityData({ userToken });
}
export { $httpChangiRecommends, $httpPhoenix, $httpProductEditor, generateApis, authorizeApis, };
